import { defineNuxtPlugin } from '#app';
import { configureBoneyard } from 'boneyard-js/vue';
import '../../bones/registry'; // eslint-disable-line import/no-unassigned-import -- side-effect: registers bone data

/**
 * Boneyard skeleton plugin (website).
 *
 * Registers bone data and configures skeleton colors.
 * The website uses server-side cookies for auth — the Boneyard CLI's
 * auth.cookies config in boneyard.config.json handles injection directly.
 * No plugin-side auth code needed, and most website skeletons are on
 * public pages that don't require authentication.
 */
export default defineNuxtPlugin({
  name: 'boneyard',
  setup() {
    configureBoneyard({
      color: 'rgba(0,0,0,0.08)',
      darkColor: 'rgba(255,255,255,0.06)',
      animate: 'pulse',
      stagger: 30,
      transition: 200,
    });
  },
});
